import React, { useContext, useEffect, useState } from "react"
import { AddBtn, BodyHeader, BookCover, BookGeneralInfo, BookMainInfo, BookPage, GrayLine, HeaderLogo, UploadBody, UploadHeader } from "./styles/bookUpload"
import axios from 'axios'
import InputBook from "./InputBook"
import InputBookSelect from "./InputBookSelect.js"
import ChapterTopic from "./chapterTopic"
import { BookUploadContext } from "./context"
import { handlePostBook, handlePostChapter, handlePostSkill, handlePostTopic, handleReadBook, handlePostPageChapter } from "./apiSender"
import { API_HOST, __AWS_ACCESS_KEY__, __AWS_REGION__, __S3_BUCKET__, __SECRET_ACCESS_KEY__ } from "../../consts"
import { get } from "lodash"
import AWS from 'aws-sdk'
import { toast } from "react-toastify"
import { Modal, ModalBody } from "reactstrap"
import getSkills from "./utils"

const BookUpload = () => {
  const [areaConhecimento, setAreaConhecimento] = useState( [] )
  const [componenteCurricular, setComponenteCurricular] = useState( [] )
  const [topicInfo, setTopicInfo] = useState( [] )
  const [etapa, setEtapa] = useState( [] )
  const [selectedFile, setSelectedFile] = useState( "" )
  const [file, setFile] = useState()
  const [isLoading, setIsLoading] = useState( false )
  const [habilidades, setHabilidades] = useState( [] )

  const { data, setData, generalInfo, handleGeneralChange } = useContext( BookUploadContext )

  useEffect( () => {
    const fetchAreasConhecimento = () => {
      axios.get( `${API_HOST}/core/area_conhecimento` ).then( ( response ) => {
        const area_conhecimento = response.data.map( ( item ) => ( {
          value: item.id,
          label: item.descricao
        } ) )
        setAreaConhecimento( area_conhecimento )
      } )
    }
    const fetchEtapa = () => {
      axios.get( `${API_HOST}/core/periodo` ).then( ( response ) => {
        const options = []
        response.data.map( ( mapResponse ) => {
          if ( mapResponse.etapa_nr ) {
            options.push( {
              value: mapResponse.id,
              label: mapResponse.descricao,
              codigo: mapResponse.etapa_nr
            } )
          }
        } )
        setEtapa( options )
      } )
    }

    fetchAreasConhecimento()
    fetchEtapa()

  }, [] )

  // useEffect(() => {
  // 	const fetchHabilidades = () => {
  // 		axios.get(`${API_HOST}/matriz_referencia/matriz_sesi?area_conhecimento_id=${generalInfo.area_conhecimento_id}`).then((res) => {
  // 		})
  // 	}
  // 	fetchHabilidades();
  // }, [generalInfo.area_conhecimento_id])

  const handleSelectedArea = ( event ) => {
    axios.get( `${API_HOST}/core/componente_curricular/${event.target.value},/filter_areas` ).then( ( response ) => {
      const componenteCurricular = response.data.map( ( item ) => ( {
        value: item.id,
        label: item.descricao
      } ) )
      setComponenteCurricular( componenteCurricular )
    } )
  }

  const handleFileChange = async ( event ) => {
    const S3_BUCKET = __S3_BUCKET__
    const REGION = __AWS_REGION__
    AWS.config.update( {
      accessKeyId: __AWS_ACCESS_KEY__,
      secretAccessKey: __SECRET_ACCESS_KEY__
    } )
    const myBucket = new AWS.S3( {
      params: { Bucket: S3_BUCKET },
      region: REGION
    } )
    let fileName = get( event.target.files[0], 'name' )
    setSelectedFile( event.target.files[0] )
    const parts = fileName.split( '.' )
    const fileExtension = parts.pop()
    if ( fileExtension !== 'pdf' ) {
      toast.error(
        'Selecione um arquivo em formato PDF para prosseguir com a ação.'
      )
      return
    }
    setIsLoading( true )

    let key = fileName
      .replace( fileExtension, "" )
      .replaceAll( ".", "" )
      .replaceAll( "_", "" )
      .replaceAll( " ", "" )
      .replaceAll( "-", "" )
    const params = {
      ACL: 'public-read',
      Body: event.target.files[0],
      Bucket: S3_BUCKET,
      Key: key
    }
    myBucket
      .putObject( params )
      .on( 'httpUploadProgress', evt => {
      } )
      .send( async ( err, data ) => {
        if ( !err ) {
          // type 2 === Book
          const bookInfo = await handleReadBook( { key: key, type: 2 } )
          const newData = []
          const bookProm = bookInfo && bookInfo.chapters.map( async ( chapter, index ) => { // TRANSFORMA CODIGO DE HABILIDADE PARA ID!!!!!
            // bookInfo.chapters.map(async (chapter, index) => {
            const chapterTopics = []
            if ( chapter.subchapters.length > 0 ) {
              chapter.subchapters.map( ( top ) => {
                chapterTopics.push( {
                  ds_topico: top.title,
                } )
              } )
            }
            const chapterSkills = []
            const skillsId = []
            if ( chapter.skills ) { // TRANSFORMA CODIGO DE HABILIDADE PARA ID!!!!!
              const requests = await chapter.skills.map( async ( skill ) => {
                await axios.get( `${API_HOST}/matriz_referencia/habilidade/book_habilidade?area_conhecimento_id=${generalInfo.area_conhecimento_id}&etapa_id=${generalInfo.etapa_id}&search=${skill}` ).then( ( response ) => {
                  if ( response.data ) {
                    const nInfo = {
                      ...response.data[0],
                      value: response.data[0].id,
                      label: response.data[0].cd_habilidade,
                    }
                    chapterSkills.push( nInfo )
                  }
                } )
              } )
              await Promise.all( requests )
              chapterSkills.map( ( cptSkill ) => skillsId.push( cptSkill.id ) )
            }

            const chapterInfo = {
              nome: chapter.title,
              topics: chapterTopics,
              capitulo: index + 1,
              skills: chapterSkills,
              capitulo_conteudo: chapter.chapter_content,
              chapter_pages_content: chapter.chapter_pages_content,
              id_livro: bookInfo.id,
              ano: generalInfo.etapa,
            }
            newData.push( chapterInfo )
          } )
          await Promise.all( bookProm ) // TRANSFORMA CODIGO DE HABILIDADE PARA ID!!!!!
          await setData( newData )
          await uploadFile( newData )
          setIsLoading( false )
        } // ENVIO PARA API
      } )
    const reader = new FileReader()

    reader.onloadend = () => {
    }
  }

  const handleNewChapter = () => {
    const newChapter = {
      id: data.length,
      chapter_title: "",
      content: 0,
      first_page: 0,
      last_page: 0,
      skills: [],
      topic: [],
    }
    setData( [...data, newChapter] )
  }

  const newChapter = ( cpt, id ) => {
    return <ChapterTopic setTopicInfo={setTopicInfo} topicInfo={topicInfo} chapterId={`${id}`} chapterInfo={cpt} />
  }

  const uploadFile = async ( newData = undefined ) => {
    const bookPayload = { ...generalInfo, titulo: generalInfo.book_title, file: file, serieano: generalInfo.etapa }
    const bookResponse = await handlePostBook( bookPayload )
    if ( newData ) {
      newData.map( async ( chapter ) => {
        const chapterPayload = { ...chapter, id_livro: bookResponse.id, descricao: chapter.nome }
        const chapterResponse = await handlePostChapter( chapterPayload )
        if ( chapterResponse && chapter.skills ) {
          chapter.skills.map( async ( skill ) => {
            await handlePostSkill( { id_capitulo: chapterResponse.id, id_habilidade: skill.id } )
          } )
        }
        if ( chapterResponse && chapter.topics ) {
          chapter.topics.map( async ( topic ) => {
            const topicPayload = { ...topic, descricao: topic.ds_topico }
            await handlePostTopic( topicPayload )
          } )
        }
        if ( chapterResponse && chapter.chapter_pages_content ) {
          chapter.chapter_pages_content.map( async ( page ) => {
            const ChapterPagesPayload = { pagina_conteudo: page.content, nr_pagina: page.page, id_capitulo: chapterResponse.id }
            await handlePostPageChapter( ChapterPagesPayload )
          } )
        }
      } )
    } else {
      data.map( async ( chapter ) => {
        const chapterPayload = { ...chapter, id_livro: bookResponse.id, descricao: chapter.nome }
        const chapterResponse = await handlePostChapter( chapterPayload )
        if ( chapterResponse && chapter.skills ) {
          chapter.skills.map( async ( skill ) => {
            await handlePostSkill( { id_capitulo: chapterResponse.id, id_habilidade: skill.id } )
          } )
        }
        if ( chapterResponse && chapter.topics ) {
          chapter.topics.map( async ( topic ) => {
            const topicPayload = { ...topic, descricao: topic.ds_topico }
            await handlePostTopic( topicPayload )
          } )
        }
        if ( chapterResponse && chapter.chapter_pages_content ) {
          chapter.chapter_pages_content.map( async ( page ) => {
            const ChapterPagesPayload = { pagina_conteudo: page.content, nr_pagina: page.page, id_capitulo: chapterResponse.id }
            await handlePostPageChapter( ChapterPagesPayload )
          } )
        }
      } )
    }
  }

  return (
    <>
      <UploadBody>
        <BodyHeader>
          <span>Informações do livro</span>
          <div>Upload do livro</div>
        </BodyHeader>
        <BookGeneralInfo>
          <BookCover>
            {selectedFile ?
              <>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#84D955"
                  }}
                >
                  <span
                    style={{
                      marginRight: "5px",
                      backgroundColor: "#F3C046",
                      padding: "5px",
                      cursor: "pointer",
                      color: "#47BEF3",
                      borderRadius: "5px"
                    }}
                    onClick={() => setSelectedFile( "" )}
                  >
                    X
                  </span>
                  <span>Arquivo salvo para envio</span>
                </div>
              </> :
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fill: "none",
                }}>
                <input style={{
                  width: "215px",
                }} type="file" onChange={handleFileChange} disabled={!generalInfo.area_conhecimento_id || !generalInfo.book_title} />
              </div>
            }
          </BookCover>
          <BookMainInfo>
            <InputBook
              placeholder="Digite o título do livro"
              width="432px"
              spanText="Título do Livro"
              value={generalInfo.book_title}
              field={"book_title"}
              handleGeneralChange={handleGeneralChange}
            />
            <div className="LowerInfo">
              <div className="NChapter">
                <InputBook
                  placeholder="Número do caderno"
                  width="203px"
                  spanText="Caderno"
                  value={generalInfo.caderno_nr}
                  field={"caderno_nr"}
                  handleGeneralChange={handleGeneralChange}
                />
              </div>
              <div className="NPages">
                <InputBook
                  placeholder="Número de páginas"
                  width="203px"
                  spanText="Páginas"
                  value={generalInfo.num_pages}
                  field={"num_pages"}
                  handleGeneralChange={handleGeneralChange}
                />
              </div>
            </div>
          </BookMainInfo>
        </BookGeneralInfo>
        <div style={{ display: "flex", alignItems: "center", justifyItems: "center", justifyContent: "center" }}>
          <InputBookSelect
            placeholder="Selecione a área do conhecimento"
            width="671px"
            spanText="Área do conhecimento"
            options={areaConhecimento}
            value={generalInfo.area_conhecimento_id}
            field={"area_conhecimento_id"}
            handleGeneralChange={handleGeneralChange}
            handleSelectedArea={handleSelectedArea}
          />
        </div>
        <div style={{
          display: "flex",
          alignItems: "center",
          justifyItems: "center",
          justifyContent: "center",
          marginTop: "15px",
          gap: "25px"
        }}>
          <InputBookSelect
            placeholder="Selecione o componente curricular"
            width="442px"
            spanText="Componente curricular"
            options={componenteCurricular}
            value={generalInfo.componente_curricular_id}
            field={"componente_curricular_id"}
            handleGeneralChange={handleGeneralChange}
          />
          <InputBookSelect
            placeholder="Selecione a etapa"
            width="200px"
            spanText="Etapa"
            options={etapa}
            value={generalInfo.etapa}
            field={"etapa_id"}
            handleGeneralChange={handleGeneralChange}
          // handleSelectedArea={handleSelectedArea}
          />
        </div>
        <div style={{
          display: "flex",
          alignItems: "center",
          justifyItems: "center",
          justifyContent: "center",
          marginTop: "20px",
          gap: "25px"
        }}>
          <GrayLine />
        </div>
        <div style={{
          display: "flex",
          alignItems: "center",
          justifyItems: "center",
          justifyContent: "center",
          marginTop: "20px",
          gap: "15px",
          flexDirection: "column",
        }}>
          <h1>Capítulos e tópicos do livro</h1>
          {data.sort( ( a, b ) => a.capitulo - b.capitulo ).map( ( cpt, index ) => newChapter( cpt, index ) )}
        </div>
        <AddBtn onClick={handleNewChapter}>
          <span>Adicionar novo capítulo</span>
        </AddBtn>
        <AddBtn onClick={uploadFile}>
          <span>Adicionar Livro</span>
        </AddBtn>
      </UploadBody>
      <Modal
        style={{ marginTop: '500px' }}
        size="lg"
        isOpen={isLoading}
      // toggle={this.toggle}
      >
        <ModalBody style={{ padding: '1.5rem' }}>
          <div style={{ textAlign: 'center' }}>
            <img
              // src={get(this.props.theme, 'loadingGif')}
              style={{ width: '42px' }}
              alt=""
            />
            <p style={{ color: '#000' }}>
              Salvando livro
            </p>
            <p style={{ color: '#f00' }}>
              Mantenha está aba do navegador aberta
              durante o processo.
            </p>
          </div>
        </ModalBody>
      </Modal>
    </>
  )
}

export default BookUpload
